type Props = {
  children: React.ReactNode;
};
export const PackageTag = ({children}: Props) => {
  return (
    <div className="text-xs text-[var(--primary)] font-medium px-2 leading-6 bg-[color-mix(in_srgb,var(--primary)_10%,_var(--navigation-background))] rounded">
      {children}
    </div>
  );
};
